module.exports = __webpack_public_path__ + "static/media/charity-event.461f1021.svg";